import { FC } from 'react'
import { IArticleBase } from '@/types'
import { getDateTimeFromUtc } from '@/utils'
import { CompanyAvatarLabelGroupLink } from '@components-v2/molecules/CompanyAvatarLabelGroupLink'
import { UserAvatarLabelGroupLink } from '@components-v2/molecules/UserAvatarLabelGroupLink'
import styles from './index.module.scss'

type Props = {
  article: IArticleBase
}

export const ArticleCardContent: FC<Props> = ({ article }) => {
  type AuthorType = 'company' | 'user' | 'null'
  let authorType: AuthorType = 'null'
  if (article?.company) {
    authorType = 'company'
  } else if (article?.opinionsUser) {
    authorType = 'user'
  }
  return (
    <div className={styles.container}>
      <p className={styles.title}>{article?.title}</p>
      {article?.category.slug === 'stories' && (
        <div className={styles.content}>
          {authorType === 'company' && (
            <CompanyAvatarLabelGroupLink
              href={`/companies/${article?.company?.slug}`}
              company={article?.company}
              supportingText={getDateTimeFromUtc(article.createdAt, 'YYYY.MM.DD')}
            />
          )}
          {authorType === 'user' && (
            <UserAvatarLabelGroupLink
              href={`/users/${article?.opinionsUser?.username}`}
              user={article?.opinionsUser}
              supportingText={getDateTimeFromUtc(article.createdAt, 'YYYY.MM.DD')}
            />
          )}
          {authorType === 'null' && (
            <p className={styles.createdAt}>{getDateTimeFromUtc(article.createdAt, 'YYYY.MM.DD')}</p>
          )}
          {/* TODO デザインないので保留 */}
          {/* <div className={styles.likeContainer}>
            <div className={styles.like}>
              <LikeSvg />
            </div>
            <span className={styles.count}>{article.likedUsersCount}</span>
          </div> */}
        </div>
      )}
    </div>
  )
}
